import React, { useEffect, useRef } from "react"
import { useStore } from "@/store"
import { DOT_SIZE, getCurrentTimeRangeState, useCurrentTime } from "./_utils"

type CurrentTimePillLayerProps = {
  startHour: number
  endHour: number
  mainCanvasRef: React.RefObject<HTMLDivElement>
}

const CurrentTimePillLayer: React.FC<CurrentTimePillLayerProps> = ({ startHour, endHour, mainCanvasRef }) => {
  const { calendarDimensions } = useStore()
  const currentTime = useCurrentTime()
  const pillRef = useRef<HTMLDivElement>(null)
  const { hourDiff, inRange } = getCurrentTimeRangeState(currentTime, startHour, endHour)

  useEffect(() => {
    const canvas = mainCanvasRef.current
    const pill = pillRef.current
    if (!canvas || !pill) return

    const onScroll = () => {
      pill.style.top = `${-canvas.scrollTop}px`
    }

    onScroll()
    canvas.addEventListener("scroll", onScroll)
    return () => canvas.removeEventListener("scroll", onScroll)
  }, [mainCanvasRef])

  const currentTimeTop =
    calendarDimensions.timeline.padding +
    calendarDimensions.timeline.offset / 2 +
    hourDiff * calendarDimensions.timeline.offset +
    (currentTime.minute / 60) * calendarDimensions.timeline.offset

  if (!inRange) {
    return null
  }

  const timeLabel = `${currentTime.hour}:${currentTime.minute.toString().padStart(2, "0")}`

  return (
    <div
      className="absolute left-0 touch-none pointer-events-none overflow-hidden z-10"
      style={{
        top: calendarDimensions.timelineContainer.top,
        width: calendarDimensions.timeline.columnWidth,
        height: calendarDimensions.timelineContainer.height,
      }}
    >
      <div ref={pillRef} className="absolute left-0" style={{ top: 0, width: calendarDimensions.timeline.columnWidth }}>
        <div
          className="absolute flex items-center justify-center bg-[#888c8d] rounded-[5px] px-1 py-0.5 text-[10px] leading-normal text-white font-medium whitespace-nowrap -translate-y-1/2"
          style={{
            right: DOT_SIZE / 2 + 5,
            top: currentTimeTop,
          }}
          data-testid="current-time-pill"
        >
          {timeLabel}
        </div>
      </div>
    </div>
  )
}

export default CurrentTimePillLayer
